import { ColumnsHelpers } from '../service/ColumnsHelpers/ColumnsHelpers';
import { LocalStorage, StorageKeyType } from '../service/Storage/Storage';
import {
    banners,
    campaigns,
    ColumnsSettingsViewDict,
    deals,
    feedFilters,
    groups,
    logs,
    phrases,
    pricePackages,
    reportsClient,
    reportsDomain,
    retargetings,
    usersProfile
} from '../typings/common';

import { getDefaultDynamicBannerColumnsFields } from './banner/banner';
import { getDefaultDynamicCampaignColumnsFields } from './campaign/campaign';
import { getDynamicDealsColumnsFields } from './deals/deals';
import { getDefaultDynamicFeedFilterColumnsFields } from './feedFilter/feedFilter';
import { getDefaultDynamicGroupColumnsFields } from './group/group';
import { getDynamicLogColumnsFields } from './log/columns';
import { getDefaultDynamicPhraseColumnsFields } from './phrase/phrase';
import { getDefaultDynamicPricePackagesColumnsFields } from './pricePackages/pricePackages';
import { getDynamicReportsClientColumnsFields } from './reportsClient/reportsClient';
import { getDynamicReportsDomainColumnsFields } from './reportsDomain/reportsDomain';
import { getDefaultDynamicRetargetingColumnsFields } from './targeting/targeting';
import { getDefaultDynamicUsersProfileColumnsFields } from './usersProfile/usersProfile';

export function getColumnsSettings(): ColumnsSettingsViewDict {
    const startDeclarations = {
        [campaigns]: getDefaultDynamicCampaignColumnsFields(),
        [groups]: getDefaultDynamicGroupColumnsFields(),
        [banners]: getDefaultDynamicBannerColumnsFields(),
        [phrases]: getDefaultDynamicPhraseColumnsFields(),
        [deals]: getDynamicDealsColumnsFields(),
        [reportsClient]: getDynamicReportsClientColumnsFields(),
        [reportsDomain]: getDynamicReportsDomainColumnsFields(),
        [logs]: getDynamicLogColumnsFields(),
        [retargetings]: getDefaultDynamicRetargetingColumnsFields(),
        [feedFilters]: getDefaultDynamicFeedFilterColumnsFields(),
        [usersProfile]: getDefaultDynamicUsersProfileColumnsFields(),
        [pricePackages]: getDefaultDynamicPricePackagesColumnsFields()
    };
    let settingsLocalStorage = LocalStorage.getItem(StorageKeyType.columnsSettings) as ColumnsSettingsViewDict;

    // нужно поддержать совместимость данных из LocalStorage
    const logColumnsSettings = LocalStorage.getItem(StorageKeyType.logColumnsSettings) as ColumnsSettingsViewDict;
    const dealsColumnsSettings = LocalStorage.getItem(StorageKeyType.dealsColumnsSettings) as ColumnsSettingsViewDict;
    const reportsColumnsSettings = LocalStorage.getItem(StorageKeyType.reportsSettings) as ColumnsSettingsViewDict;
    const reportsDomainColumnsSettings = LocalStorage.getItem(
        StorageKeyType.reportsDomainSettings
    ) as ColumnsSettingsViewDict;

    settingsLocalStorage = {
        ...logColumnsSettings,
        ...dealsColumnsSettings,
        ...reportsColumnsSettings,
        ...reportsDomainColumnsSettings,
        ...settingsLocalStorage
    };

    return ColumnsHelpers.getColumns(startDeclarations, settingsLocalStorage);
}
